import {
  MailingDigitalDataRequest,
  MailingFileRequest,
  MailingResponseData,
} from "../models/backend/mailing/mailing";
import useConsultaiApi from "./context/hooks/useConsultaiApi";
import type { CreateContractRequest } from "../models/contract.types";

export const useMailingOnBoardingService = (): {
  getMailing: (id: string) => Promise<MailingResponseData>;
  putMailingStep: (id: string, step: number) => Promise<string>;
  sendMailingFile: (data: MailingFileRequest) => Promise<string>;
  sendMailingDigitalData: (id: string, mailingDigitalData: MailingDigitalDataRequest) => Promise<string>;
  finishMailingFlow: (id: string) => Promise<any>;
  sendMailingUserData: (publicId: string, MailingUserData: any) => Promise<string>;
  getMailingSignedContract: (id: string) => Promise<any>;
  createContract: (contractData: CreateContractRequest) => Promise<any>;
  getContract: (contractData: { order: number; unidadeId: number; publicId: string; sign?: string }) => Promise<any>;
} => {
  const consultaiApi = useConsultaiApi();

  const getMailing = async (id: string): Promise<MailingResponseData> => {
    return await consultaiApi.get<MailingResponseData>(`/mailing/${id}`, 1);
  };

  const getMailingSignedContract = async (id: string): Promise<any> => {
    return await consultaiApi.get<any>(`/mailing/${id}/signed-contract`, 1);
  };


  const createContract = async (contractData: CreateContractRequest): Promise<any> => {
    // Fazer a requisição diretamente com axios configurado para receber PDF
    try {
      const response = await consultaiApi.instance?.post(`v2/Contract/create`, contractData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${consultaiApi.accessToken}`
        },
        responseType: 'arraybuffer' // Receber como ArrayBuffer
      });
      
      return response?.data;
    } catch (error) {
      console.error('Erro ao criar contrato:', error);
      throw error;
    }
  };

  const getContract = async (contractData: { order: number; unidadeId: number; publicId: string; sign?: string }): Promise<any> => {
    // Fazer a requisição GET com query parameters
    try {
      let url = `v2/Contract?order=${contractData.order}&unidadeId=${contractData.unidadeId}&publicId=${contractData.publicId}`;
      
      // Adicionar parâmetro sign se fornecido
      if (contractData.sign) {
        url += `&sign="${contractData.sign}"`;
      }
      
      const response = await consultaiApi.instance?.get(url, {
        headers: {
          Authorization: `Bearer ${consultaiApi.accessToken}`
        },
        responseType: 'arraybuffer' // Receber como ArrayBuffer
      });
      
      return response?.data;
    } catch (error) {
      console.error('Erro ao buscar contrato:', error);
      throw error;
    }
  };

  const putMailingStep = async (id: string, step: number) => {
    return await consultaiApi.put<string>(`/mailing/${id}/step`, 1, { step });
  };

  const sendMailingDigitalData = async (
    id: string,
    mailingDigitalData: MailingDigitalDataRequest
  ) => {
    return await consultaiApi.post<string>(`/mailing/${id}/digital-data`, 1, {
      mailingDigitalData,
    });
  };

  const sendMailingUserData = async (
    publicId: string,
    MailingUserData: any
  ) => {
    return await consultaiApi.post<string>(`/mailing/user-data`, 1, {
      publicId,
      MailingUserData,
    });
  };

  const sendMailingFile = async (data: MailingFileRequest) => {
    const { publicId, ...rest } = data;
    return await consultaiApi.post<string>(`/mailing/${publicId}/file`, 1, {
      ...rest,
    });
  };

  const finishMailingFlow = async (id: string) => {
    return await consultaiApi.post(`/Inquiries/mailing/${id}/send`, 1);
  };

  return {
    getMailing,
    putMailingStep,
    sendMailingFile,
    sendMailingDigitalData,
    finishMailingFlow,
    sendMailingUserData,
    getMailingSignedContract,
    createContract,
    getContract,
  };
};
export default useMailingOnBoardingService;